import React, { useState, useEffect } from 'react';
import { navLinks } from '../data/mock';
import { Menu, X, ChevronDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-[#1A2B3C]/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
      style={{ borderBottom: isScrolled ? '2px solid #D4AF37' : '2px solid transparent' }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="#home" className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full border-2 border-[#D4AF37] flex items-center justify-center bg-[#1A2B3C]">
                <span className="font-playfair text-[#D4AF37] text-xl font-bold">F</span>
              </div>
              <div className="flex flex-col">
                <span className="font-playfair text-white text-xl tracking-wider">FIJA</span>
                <span className="font-lato text-[#D4AF37] text-xs tracking-widest uppercase">Healthcare Specialist</span>
              </div>
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              link.dropdown ? (
                <DropdownMenu key={link.id}>
                  <DropdownMenuTrigger className="flex items-center gap-1 font-lato text-white/90 hover:text-[#D4AF37] transition-colors duration-300 text-sm tracking-wide">
                    {link.label}
                    <ChevronDown className="w-4 h-4" />
                  </DropdownMenuTrigger>
                  <DropdownMenuContent className="bg-[#1A2B3C] border border-[#D4AF37]/30">
                    {link.dropdown.map((item, idx) => (
                      <DropdownMenuItem
                        key={idx}
                        className="font-lato text-white/90 hover:text-[#D4AF37] hover:bg-[#D4AF37]/10 cursor-pointer"
                        onClick={() => scrollToSection('#locations')}
                      >
                        {item}
                      </DropdownMenuItem>
                    ))}
                  </DropdownMenuContent>
                </DropdownMenu>
              ) : (
                <button
                  key={link.id}
                  onClick={() => scrollToSection(link.href)}
                  className="font-lato text-white/90 hover:text-[#D4AF37] transition-colors duration-300 text-sm tracking-wide"
                >
                  {link.label}
                </button>
              )
            ))}
            <button
              onClick={() => scrollToSection('#contact')}
              className="book-tour-btn font-lato text-sm px-6 py-2.5 bg-[#D4AF37] text-[#1A2B3C] rounded hover:bg-[#D4AF37]/90 transition-all duration-300 font-medium tracking-wide"
            >
              Book a Tour
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-white p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-[#1A2B3C]/98 backdrop-blur-md border-t border-[#D4AF37]/30 py-6">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.href)}
                className="block w-full text-left font-lato text-white/90 hover:text-[#D4AF37] py-3 px-4 transition-colors duration-300"
              >
                {link.label}
              </button>
            ))}
            <div className="px-4 pt-4">
              <button
                onClick={() => scrollToSection('#contact')}
                className="book-tour-btn w-full font-lato text-sm px-6 py-3 bg-[#D4AF37] text-[#1A2B3C] rounded hover:bg-[#D4AF37]/90 transition-all duration-300 font-medium"
              >
                Book a Tour
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
